import { lazy } from 'react';

// Lazy Loading für Seiten-Komponenten
export const HomePage = lazy(() => import('../pages/HomePage'));
export const ImpressumPage = lazy(() => import('../pages/ImpressumPage'));
export const PrivacyPage = lazy(() => import('../pages/PrivacyPage'));
export const AGBPage = lazy(() => import('../pages/AGBPage'));
export const AffiliatePage = lazy(() => import('../pages/AffiliatePage'));
export const BeratungsterminPage = lazy(() => import('../pages/BeratungsterminPage'));

// Lazy Loading für größere Komponenten
export const ServicesSection = lazy(() => import('../components/ServicesSection'));
export const ReferencesSection = lazy(() => import('../components/ReferencesSection'));
export const TestimonialsSection = lazy(() => import('../components/TestimonialsSection'));
export const CallToActionSection = lazy(() => import('../components/CallToActionSection'));

// Error Boundary für Lazy Components
export { default as LazyErrorBoundary } from './LazyErrorBoundary';
